import { environment } from '@/env/environment';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CdnService {
    public static url(resource: string): string {
        return [environment.cdn, resource.replace(/^\/+/, '')].join('/');
    }
}
